import styled from "styled-components";
import { iPadDown } from "./mediaQueries";

const SubmitButton = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1.57vw;

    ${iPadDown} {
        margin-top: 4.84vw;
    }
`

export default SubmitButton;
